import { useEffect, useState } from 'react'
import { useTheme } from '@mui/material'

import PopupSectionRow from 'components/popup/PopupSectionRow'
import { t } from 'i18next'
import { StarBorderRounded } from '@mui/icons-material'
import { SettingsSectionProps } from './SettingsSection'
import { getDefaultCalendar } from 'components/providers/GetChangesProvider'
import { AccountDoc, GroupDoc } from 'types/api/changes'
import CalendarSelectPopup from '../CalendarSelectPopup'
import { Model } from 'types/model'
import Logger from 'services/Logger'
import { SelectableItem } from '../SelectItemWithSearchPopup'
import { ICalendar } from 'types/google_events'
import { CurrentConvertedCalendars } from 'utils/google_events'
import { removePrefix } from 'utils/object'
import { localGroupById } from 'services/db/Queries/GroupQueries'
import { prepareCalendars, prepareSections } from '../eventInfo/EventPopup'
import { performUpdateGroupSettings } from '../groupInfo/SettingsForCalendarSection'
import { DefaultCalendar } from 'assets/icons'

export interface DefaultCalendarSectionProps extends SettingsSectionProps {
  account: Model<AccountDoc>
}

export default function DefaultCalendarSection(
  props: DefaultCalendarSectionProps
) {
  const theme = useTheme()
  const [showCalendarPicker, onShowCalendarPicker] = useState(false)

  const [defaultGroup, setDefaultGroup] = useState<GroupDoc | undefined>(
    undefined
  )

  useEffect(() => {
    getDefaultCalendar().then((group) => {
      setDefaultGroup(group)
    })
  }, [showCalendarPicker])

  const onCalendarPick = (calendar: SelectableItem) => {
    onShowCalendarPicker(false)
    Logger.orange('calendar', calendar)
    Logger.orange('calendar', CurrentConvertedCalendars)
    const isSharedCalendar =
      (calendar as ICalendar)?.primaryCalendarEmail !== undefined
    const thirdPartyCalendar = CurrentConvertedCalendars.find(
      (userCalendar) => {
        return userCalendar.id === removePrefix(calendar.id ?? '')
      }
    )
    const newGroupId = isSharedCalendar
      ? `${thirdPartyCalendar?.prefix}${thirdPartyCalendar?.primaryCalendarEmail}`
      : calendar.id
    Logger.orange('calendar', newGroupId)
    localGroupById(newGroupId ?? '').then((group) => {
      if (group && newGroupId) {
        performUpdateGroupSettings(props.userSettings, newGroupId, {
          Default: '1'
        })
        props.setMenuOpen(false)
      }
    })
  }

  const [calendars, setCalendars] = useState<SelectableItem[]>([])
  useEffect(() => {
    prepareCalendars(props.account, undefined, true).then((calendars) => {
      setCalendars(calendars)
    })
  }, [])

  return (
    <CalendarSelectPopup
      group={defaultGroup}
      account={props.account}
      eventHook={undefined}
      onlyCalendarPick
      onCalendarPick={onCalendarPick}
      calendars={prepareSections(
        calendars,
        false,
        defaultGroup?._id,
        undefined
      )}
      open={showCalendarPicker}
      setOpen={onShowCalendarPicker}
      SupplementaryGroupsIDs={[]}
    >
      <div>
        <PopupSectionRow
          title={t('defaultCalendar')}
          iconClass="icon-regular"
          maxWidthIcon={18}
          engulfEntireRow
          icon={<DefaultCalendar />}
          cursor="pointer"
          value={defaultGroup?.Name}
          valueColor={theme.palette.text.disabled}
          action={() => {
            onShowCalendarPicker(true)
          }}
        />
      </div>
    </CalendarSelectPopup>
  )
}
